import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=5053fad6&scoped=true"
import script from "./ColorInput.vue?vue&type=script&lang=js"
export * from "./ColorInput.vue?vue&type=script&lang=js"
import style0 from "./ColorInput.vue?vue&type=style&index=0&id=5053fad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5053fad6",
  null
  
)

export default component.exports